import React from 'react';
import Button from './Button';
import { useI18n } from '../../context/I18nContext';

interface ActionButtonsProps {
  onCancel: () => void;
  onValidate: () => void;
  onAbandon?: () => void;
  abandonText?: string;
  validateText?: string;
  showAbandon?: boolean;
  loading?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onCancel,
  onValidate,
  onAbandon,
  abandonText,
  validateText,
  showAbandon = false,
  loading = false,
}) => {
  const { t } = useI18n();

  return (
    <div className="flex justify-end gap-2">
      {showAbandon && onAbandon && (
        <Button
          type="button"
          variant="ghost"
          size="md"
          onClick={onAbandon}
          disabled={loading}
        >
          {abandonText || t('common.abandon')}
        </Button>
      )}

      <Button
        type="button"
        variant="ghost"
        size="md"
        onClick={onCancel}
        disabled={loading}
      >
        {t('common.cancel')}
      </Button>

      <Button
        type="button"
        variant="primary"
        size="md"
        onClick={onValidate}
        disabled={loading}
      >
        {validateText || t('common.validate')}
      </Button>
    </div>
  );
};

export default ActionButtons;
